module.exports = __webpack_public_path__ + "img/wolframmathematica.f07ca1bb.png";